import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AiOutlinePlusCircle } from "react-icons/ai";
import { v4 as uuidv4 } from "uuid";
import { setOnboardingStep } from "../../redux/appSlices/collaborator/collaboratorSlice";
import ShowVideo from "../UI/ShowVideo";
import { useNavigate } from "react-router-dom";
import { usePatchCollaboratorMutation } from "../../redux/appSlices/collaborator/collaboratorApiSlice";
import useActiveProfilePatch from "../../hooks/useActiveProfilePatch";
import LottieChangeLang from "../animation/LottieChangeLang";
import useCollaboratorRestriction from "../../hooks/useCollaboratorRestriction";
import { translation } from "../../translation";
import { toast } from "react-toastify";
import { sanitizeVideosForApi } from "../../utils/videos";
import { languages, profileRedirectMap } from "../../constants";

const Videos = ({ edit, finalStep, setFinalStep, setOpenEditPopup }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const videosTranslation = useSelector((state) => state.translation.Videos);
  const videosTranslation = translation.onboarding.videos;
  const lang = useSelector(
    (state) => state.collaborator.collaboratorInfo.language
  );

  const collaborator = useSelector(
    (state) => state.collaborator.collaboratorInfo
  );

  const restriction = useCollaboratorRestriction();

  const [patchCollaborator, { isLoading: collabLoading }] = usePatchCollaboratorMutation();
  const [patchActiveProfile, { isLoading: activeLoading }] = useActiveProfilePatch();
  const isLoading = edit ? activeLoading : collabLoading;

  const [listVideos, setListVideos] = useState(collaborator.videos);

  useEffect(() => {
    if (restriction.restrict_videos) {
      setListVideos(restriction.videos)
    }
  }, [restriction])

  // const [finalStep, setFinalStep] = useState(false);

  // ############### DEV AREA
  // ######################
  // ########################################################

  const [safe, setSafe] = useState(true);
  const [loading, setLoading] = useState();

  const handleAdd = () => {
    setListVideos([
      ...listVideos,
      {
        _id: uuidv4(),
        description: languages.reduce((acc, l) => {
          acc[l] = "";
          return acc;
        }, {}),
        type: 1,
        url: "",
      },
    ]);
  };

  const handleChange = (e, index, value) => {
    const newlist = [...listVideos];
    if (e.target.name == "description") {
      newlist[index] = {
        ...newlist[index],
        [e.target.name]: languages.reduce((acc, l) => {
          acc[l] = l === lang ? e.target.value : '';
          return acc;
        }, {}),
      };
    } else if (value) {
      newlist[index] = {
        ...newlist[index],
        type: `${value}`,
      };
    } else {
      newlist[index] = {
        ...newlist[index],
        [e.target.name]: e.target.value,
      };
    }

    setListVideos(newlist);
  };

  const handleDelete = (_id) => {
    const newList = listVideos.filter((item, i) => item._id !== _id);
    setListVideos(newList);
  };

  const handleSubmit = () => {
    const content = {
      ...(edit ? {} : { onboarding_step: 10 }),
      videos: sanitizeVideosForApi(listVideos),
    };
    const patchRequest = edit
      ? patchActiveProfile({ content })
      : patchCollaborator({ id: collaborator._id, content });

    patchRequest
      .unwrap()
      .then()
      .catch(() => toast.error(edit ? translation?.updateErrorMessage?.[lang] : translation?.saveErrorMessage?.[lang]))
  };

  const handleFinishClick = async () => {
    const collabId = collaborator.collaborator_id;
    const redirectedId =
      profileRedirectMap[`/${collabId}`]?.replace("/", "") ?? collabId;
    navigate(`/profile/${redirectedId}`, { replace: true });
  };

  // ########################################################
  // ######################
  // ############### END DEV AREA

  return (
    <>
      {finalStep ? (
        <section className="pt-[7vh] mx-5">
          <div className="flex flex-col justify-center items-center">
            <div>
              <img
                src="/assets/img/logo-black.svg"
                className="w-[139px] object-contain"
              />
            </div>
            <div className="text-xl max-w-[239px] mt-12 text-center">
              {videosTranslation.title2[lang]}
            </div>
          </div>
          <div className="h-[300px]">
            <LottieChangeLang />
          </div>

          <div className="button-container">
            <button className={`btn-welcome ${lang === 'ar' ? '!font-readexRegular' : ''}`} onClick={handleFinishClick}>
              {videosTranslation.buttonFinish?.[lang]}
            </button>
          </div>
        </section>
      ) : (
        <section className={`pt-[7vh] mx-5 pb-[120px] ${lang === 'ar' ? 'font-readexRegular' : 'font-SteradianRegular'}`}>
          <div>
            <div className={`text-2xl ${lang === 'ar' ? 'font-lalezarRegular' : 'font-SteradianMedium'}`}>
              {videosTranslation.title[lang]}
            </div>
            <div className="text-lg mt-5">
              {videosTranslation.subtitle[lang]}
            </div>
            {/* {!restriction.restrict_videos && ( */}
            {/* // <> */}
            <div className="mt-7">
              {listVideos.map((video, i) =>
                restriction.restrict_videos ? (
                  <div>
                    <div className="flex items-center justify-between w-[122px] h-[44px] bg-labelsBg border border-labels rounded-lg py-2 px-5 mt-[20px]">
                      {video?.type === '1' ? 'Youtube' : "Vimeo"}
                      <img src="../../assets/img/icons/lock.svg" className="w-[15px] h-[15px]" />
                    </div>

                    <p className="my-[10px]">{video?.url}</p>
                    <p className="my-[10px]">{video?.description?.[lang]}</p>

                  </div>
                ) : (
                  <ShowVideo
                    key={video._id}
                    data={video}
                    index={i}
                    lang={lang}
                    handleChange={handleChange}
                    handleDelete={handleDelete}
                    videosTranslation={videosTranslation}
                  />
                )
              )}
            </div>
            {!restriction.restrict_videos && (
              <div
                onClick={handleAdd}
                className={`flex mt-5 text-labels items-center gap-3 cursor-pointer ${lang === 'ar' ? 'font-lalezarRegular' : 'font-SteradianMedium'}`}
              >
                <AiOutlinePlusCircle />
                {videosTranslation.button[lang]}
              </div>
            )}
          </div>
          <div className="button-container">
            <button
              className={`${safe ? "btn-fields btn-active" : "btn-fields"} ${lang === 'ar' ? '!font-readexRegular' : ''}`}
              id="btn-next"
              onClick={
                edit
                  ? (e) => {
                    handleSubmit(e);
                    setOpenEditPopup(false);
                  }
                  : handleSubmit
              }
              disabled={!safe}
            >
              {edit ? (
                <img
                  src="/assets/img/loaders/loading.gif"
                  style={{
                    display: loading ? undefined : "none",
                    padding: "2px",
                  }}
                  width="23px"
                  alt=""
                  className="ml-[45%]"
                />
              ) : null}
              {loading
                ? null
                : edit
                  ? videosTranslation?.buttonSave[lang]
                  : videosTranslation?.buttonNext[lang]}
            </button>
          </div>
        </section>
      )}
    </>
  );
};

export default Videos;
